export default __webpack_public_path__ + "static/media/lp-hero-text.8b2efa7c.png";